import axios from 'axios'
import { apiHeader, SERVER_URL } from '../config'

export const getAllCoachs = async () => {
    const tokenAdmin = localStorage.getItem('tokenAdmin')!
    return (await axios.get(`${SERVER_URL}/coachs`, apiHeader(tokenAdmin))).data
}

export const resetPassword = async (pseudo: string) => {
    return await axios.post(`${SERVER_URL}/coachs/reset-password`, { pseudo }, apiHeader())
}
